import OptimizerEditDto from './OptimizerEditDto';

export class ShgoOptimizerEditDto extends OptimizerEditDto {
	constructor() {
		super();
		/** @type {number} */
		this.iters = null;
		/** @type {number} */
		this.n = null;
		/** @type {string} */
		this.method = null;
		/** @type {string} */
		this.samplingMethod = null;
		/** @type {number} */
		this.workers = null;
	}

	/**
	 * @typedef {Object} _ShgoOptimizerEditDtoProps
	 * @property {number} iters
	 * @property {number} n
	 * @property {string} method
	 * @property {string} samplingMethod
	 * @property {number} workers
	 *
	 * @typedef {import("./OptimizerEditDto").OptimizerEditDtoProps & _ShgoOptimizerEditDtoProps} ShgoOptimizerEditDtoProps
	 */
	/**
	 *
	 * @param {ShgoOptimizerEditDtoProps} props
	 * @returns {ShgoOptimizerEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.iters = props.iters;
		this.n = props.n;
		this.method = props.method;
		this.samplingMethod = props.samplingMethod;
		this.workers = props.workers;
		return this;
	}
}

export default ShgoOptimizerEditDto;